import type { Modifier } from "@popperjs/core";
import { useDisclosure } from "@ecco/ui/use-disclosure";
import { getInsetFromPlacement, type PlacementWithLogical } from "@ecco/ui/theme-tools";

type PlacementY = "top" | "bottom";

export const calculateTop = (placementY: PlacementY) => (placementY === "top" ? 0 : "-100%");

export const calculateLeft = (placement: PlacementWithLogical) => {
    if (placement.includes("-start")) {
        return "-50%";
    } else if (placement.includes("-end")) {
        return "50%";
    } else {
        return 0;
    }
};

export const useMarkerPopover = (top: number, left: number) => {
    const { onToggle, onOpen, onClose, isOpen } = useDisclosure();

    const placementY: PlacementY = top > 50 ? "top" : "bottom";
    const placementX = left > 33 ? "end" : "start";
    const placement: PlacementWithLogical =
        left > 33 && left < 66 ? placementY : `${placementY}-${placementX}`;

    const customInset = getInsetFromPlacement(placement);

    const customPosition: Modifier<"customPosition", any> = {
        name: "customPosition",
        enabled: true,
        phase: "beforeWrite",
        requires: ["computeStyles"],
        fn: ({ state }) => {
            // eslint-disable-next-line no-param-reassign
            state.styles.popper.inset = customInset;
        },
        effect:
            ({ state }) =>
            () => {
                const popper = state.elements.popper;
                popper.style.inset = customInset;
            },
    };

    return {
        isOpen,
        onOpen,
        onClose,
        onToggle,
        placement,
        placementY,
        popoverProps: {
            isLazy: true,
            isOpen,
            onClose,
            placement,
            returnFocusOnClose: false,
            modifiers: [customPosition],
            flip: false,
            gutter: 0,
            arrowPadding: 0,
        },
    };
};
